import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { appLoadDataAsyncThunk, startDevTeamRewardClaimAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';

export default function Index({ networkID, provider, address }) {

    const { analytics } = useSelector(state => state.bank);
    const { allowClaimDevelopmentReward } = analytics;
    const dispatch = useDispatch();
    useEffect(() => {

        dispatch(appLoadDataAsyncThunk({ networkID, provider, address }))
        return () => {

        }
    }, [])


    return (
        <div className='method-component'>
            <h2>Make DBN {allowClaimDevelopmentReward ? 'UnClaimable':'Claimable'} For Dev team</h2>
            <p>You can manage DBN by performing actions. All actions that you can perform are listed in sidebar</p>
            <Form noValidate>
                <div className='contact-form'>
                    <div className='contact-us '>
                        <div className='inner-row'>
                            <CustomButton
                                title={allowClaimDevelopmentReward ? 'Disable Claim' : 'Allow Claim'}
                                type="submit"
                                slice={'bank'}
                                action={"startDevTeamRewardClaimAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                                onClick={(e) =>{
                                    e.preventDefault();
                                    dispatch(startDevTeamRewardClaimAsyncThunk({ networkID, provider, address }))
                                }
                            }
                            />
                        </div>

                    </div>
                </div>
            </Form>
        </div>
    )
}
